<template>
  <div class="container-fluid LoginForm ">
    <div class="col-lg-1"></div>
    <div class="margin-Top-10Perc col-sm-10 col-md-10 col-lg-10">
      <div class="panel panel-default">
      <!-- <div class="panel-heading">Login</div> -->
        <div class="panel-body width-90Perc">
          <form class="margin-Top-5Perc">
            <div class="form-group" :class="{'has-error': errors.has('username') }">
              <label class="form-control-label" for="username">Username:</label>
              <input type="text" class="form-control" v-validate="'required'"  placeholder="Enter Username"
                  name="username" v-model="username" autocomplete="off">
              <span class="text-danger" v-show="errors.has('username')">{{ errors.first('username') }}</span>
            </div>
            <div class="form-group" :class="{'has-error': errors.has('password') }">
              <label for="password">Password:</label>
              <input type="password" v-validate="'required'" class="form-control"  placeholder="Enter Password" name="password" v-model="password" id="passwordId">
              <span class="p-viewer">
                <i class="glyphicon glyphicon-eye-open color-orange cursor-pointer" v-if="!showPassword" aria-hidden="true" @click="revealPassword"></i>
                <i class="glyphicon glyphicon-eye-close color-orange cursor-pointer" v-else aria-hidden="true" @click="revealPassword"></i>
              </span>
              <span class="text-danger" v-show="errors.has('password')">{{ errors.first('password') }}</span>
            </div>
            <div class="col-md-12 text-center padding-Top-5Perc margin-Bottom-5Perc">
              <button type="submit" value="submit" class="btn btn-default margin-Top-1Perc" @click.prevent="authenticateUser">Login</button>
            </div>
            <div class="row margin-Top-5Perc">
              <div class="col-md-12 col-lg-12 text-center text-color-orange cursor-pointer text-decoration-underline" @click="openForgotPassword">Forgot Password?</div>
            </div>
            <p v-if="errors.length">
              <b>Please correct the following error(s):</b>
              <ul>
                <li v-for="error in errors " :key="error"> {{ error }}</li>
              </ul>
            </p>
          </form>
        </div>
      </div>
    </div>
    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-1">
    </div>
    <forgot-password-overlay v-if="showForgotPasswordScreen" @closeOverlay="closeFPOverlay"></forgot-password-overlay>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="alertErrorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>
  </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { courseService } from '@/server-util/course-service'
import { constants } from '@/utils/constants'
import { trackerService } from '@/server-util/tracker-service'
import { loginService } from '@/server-util/login-service'
import { participantService } from '@/server-util/participant-service'
import { groupService } from '@/server-util/group-service'
import { emailService } from '@/server-util/email-service'
import AlertBox from '@/components/AlertOverlay'
import ForgotPasswordOverlay from '@/components/ForgotPasswordOverlay'
import auth0 from 'auth0-js'
import server from '../utils/server'
export default {
  created: function () {
    this.setDefaultValues()
  },
  mounted: function () {
    let auth0script = document.createElement('script')
    auth0script.setAttribute('src', 'https://cdn.auth0.com/js/auth0/9.11/auth0.min.js')
    document.head.appendChild(auth0script)
  },
  data: function () {
    return {
      username: '',
      password: '',
      errorMsg: '',
      showAlertDialog: false,
      alertErrorMsg: '',
      showSpinner: false,
      showForgotPasswordScreen: false,
      realmOrConnection: '',
      clientId: '',
      showPassword: false,
      passwordInterval: null
    }
  },
  methods: {
    revealPassword: function () {
      if (this.password.length > 0) {
        this.showPassword = !this.showPassword
        var x = document.getElementById('passwordId')
        if (x !== undefined && x !== 'undefined' && x !== null && x !== 'null') {
          x.type = this.showPassword ? 'text' : 'password'
        } else {
          this.clearPasswordInterval()
        }
      }
    },
    clearPasswordInterval: function () {
      if (this.passwordInterval !== undefined && this.passwordInterval !== null) {
        clearInterval(this.passwordInterval)
      }
    },
    resetIsLogoutStateForCurrentPlatform: function (accessToken) {
      var store = this.$store
      if (
        store.state.access_token !== undefined && store.state.access_token !== null && store.state.access_token !== ''
      ) {
        participantService
          .updateLogoutForPlatform(
            store.state.access_token,
            constants.ClientPlatform.Admin
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              participantService.getUserProfile(accessToken).then(responseObj2 => {
                if (responseObj2.status === 200) {
                  this.clearPasswordInterval()
                  let respData2 = responseObj2.data
                  store.state.curr_user = respData2
                  var cookies2 = this.$cookies
                  var stringifiedUserData = JSON.stringify(respData2)
                  cookies2.set(constants.LOGIN_USER_COOKIE, stringifiedUserData)
                  localStorage.setItem(constants.LOGIN_USER_COOKIE, stringifiedUserData)
                  var userDataForActivity = 'UserName:{0}, FullName: {1}'
                  userDataForActivity = userDataForActivity.replace('{0}', store.state.curr_user.UserName)
                  userDataForActivity = userDataForActivity.replace('{1}', store.state.curr_user.FirstName + ' ' + store.state.curr_user.LastName)
                  userDataForActivity = userDataForActivity.replace('{2}', store.state.curr_user.Email)
                  // AK: Hide Spinner
                  // this.showSpinner = false
                  this.$store.commit('setIsLoading', false)
                  var trackingObj = {
                    ActivityData: 'Logged In as : ' + userDataForActivity,
                    ActivityType: constants.AdminActivityType.Login,
                    AdminAction: constants.AdminActionType.Default,
                    ScreenName: 'LOGIN',
                    UserRole: store.state.curr_user.AccountType,
                    IsPrivate: false
                  }
                  if (store.state.curr_user.AccountType !== constants.UserAccountType.Admin && store.state.curr_user.AccountType !== constants.UserAccountType.Group_Admin) {
                    this.showAlertDialog = true
                    var cookies = this.$cookies
                    cookies.remove(constants.LOGIN_COOKIE_KEY)
                    cookies.remove(constants.LOGIN_USER_COOKIE)
                    this.alertErrorMsg = 'You are not authorized to log in to the admin website.'
                    store.state.isUserProfileLoaded = false
                    return
                  }
                  store.state.isUserProfileLoaded = true
                  store.state.currDashboardTabSelection = 1
                  this.getCourses()
                  this.getSenderEmailList()
                  this.getProgressionEmailTemplates()
                  trackerService.logActivity(accessToken, trackingObj).then(responseObj3 => {
                    if (responseObj3.status === 200) {
                      console.log('LOGGED ACTIVITY : ')
                    }
                  })
                }
              })
            } else {
              // AK: Hide Spinner
              this.$store.commit('setIsLoading', false)
              this.showAlertDialog = true
              this.alertErrorMsg = 'Sorry. we couldn\'t find an account with the credentials provided.'
            }
          }, errorObj => {
            this.$store.commit('setIsLoading', false)
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('updateLogoutForPlatform Error::: ' + this.errorMsg)
          })
      } else {
        console.log(
          'Access token not found hence declined UPDATE LOGOUT FLAG FOR CURRENT PLATFORM on Server.'
        )
      }
    },
    setDefaultValues: function () {
      this.realmOrConnection = server.realmOrConnection()
      this.clientId = server.clientId()
      this.startPasswordListener()
      // console.log('this.clientId: ' + this.clientId + ' this.realmOrConnection: ' + this.realmOrConnection)
    },
    startPasswordListener: function () {
      this.passwordInterval = setInterval(() => {
        if (this.password.length === 0) {
          this.showPassword = false
          var x = document.getElementById('passwordId')
          if (x !== undefined && x !== 'undefined' && x !== null && x !== 'null') {
            x.type = this.showPassword ? 'text' : 'password'
          } else {
            this.clearPasswordInterval()
          }
        }
      }, 100)
    },
    closeFPOverlay (value) {
      // AK: Used to close the forgot password overlay
      this.showForgotPasswordScreen = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    openForgotPassword: function () {
      // AK: Used to open the forgot password overlay
      this.showForgotPasswordScreen = true
      // AK: Disable background scrolling
      this.$store.state.isOverlayVisible = true
    },
    authenticateUserV2: function (e) {
      // AK: Added Validations
      if (this.username === undefined || this.username === 'undefined' || this.username === null || this.username === 'null' || this.username === '' || this.username.trim().length === 0) {
        this.showAlertDialog = true
        this.alertErrorMsg = 'Username can\'t be empty. Please fill in username and try again.'
        return
      } else if (this.password === undefined || this.password === 'undefined' || this.password === null || this.password === 'null' || this.password === '' || this.password.trim().length === 0) {
        this.showAlertDialog = true
        this.alertErrorMsg = 'Password can\'t be empty. Please fill in password and try again.'
        return
      }
      var cookies = this.$cookies
      var store = this.$store
      // AK: Show Spinner
      this.$store.commit('setIsLoading', true)
      var webAuth = new auth0.WebAuth({
        domain: 'dev-mentoradigital.auth0.com',
        clientID: this.clientId,
        scope: 'openid',
        audience: 'https://dev-mentoradigital.auth0.com/userinfo'
      })
      webAuth.client.login({
        realm: this.realmOrConnection,
        username: this.username + ':isadmin',
        password: this.password
      },
      (err1, authResult) => {
        if (!err1) {
          const auth0AccessToken = authResult.accessToken
          webAuth.client.userInfo(auth0AccessToken, (err2, user) => {
            if (!err2) {
              const mentoraDBAccessToken = user.nickname
              // console.log('user: ' + JSON.stringify(user))
              store.state.isComingFromLogin = true
              // let respData = responseObj.data
              let accessToken = mentoraDBAccessToken
              store.state.access_token = accessToken
              cookies.set(constants.LOGIN_COOKIE_KEY, accessToken, 31535999)
              participantService.getUserProfile(accessToken).then(responseObj2 => {
                if (responseObj2.status >= 200 && responseObj2.status < 300) {
                  let respData2 = responseObj2.data
                  store.state.curr_user = respData2
                  var cookies2 = this.$cookies
                  var stringifiedUserData = JSON.stringify(respData2)
                  cookies2.set(constants.LOGIN_USER_COOKIE, stringifiedUserData)
                  localStorage.setItem(constants.LOGIN_USER_COOKIE, stringifiedUserData)
                  var userDataForActivity = 'UserName:{0}, FullName: {1}'
                  userDataForActivity = userDataForActivity.replace('{0}', store.state.curr_user.UserName)
                  userDataForActivity = userDataForActivity.replace('{1}', store.state.curr_user.FirstName + ' ' + store.state.curr_user.LastName)
                  userDataForActivity = userDataForActivity.replace('{2}', store.state.curr_user.Email)
                  // AK: Hide Spinner
                  // this.showSpinner = false
                  this.$store.commit('setIsLoading', false)
                  var trackingObj = {
                    ActivityData: 'Logged In as : ' + userDataForActivity,
                    ActivityType: constants.AdminActivityType.Login,
                    AdminAction: constants.AdminActionType.Default,
                    ScreenName: 'LOGIN',
                    UserRole: store.state.curr_user.AccountType,
                    IsPrivate: false
                  }
                  if (store.state.curr_user.AccountType !== constants.UserAccountType.Admin && store.state.curr_user.AccountType !== constants.UserAccountType.Group_Admin) {
                    this.showAlertDialog = true
                    var cookies = this.$cookies
                    cookies.remove(constants.LOGIN_COOKIE_KEY)
                    cookies.remove(constants.LOGIN_USER_COOKIE)
                    this.alertErrorMsg = 'You are not authorized to log in to the admin website.'
                    store.state.isUserProfileLoaded = false
                    return
                  }
                  store.state.isUserProfileLoaded = true
                  this.getCourses()
                  this.getSenderEmailList()
                  this.getProgressionEmailTemplates()
                  trackerService.logActivity(accessToken, trackingObj).then(responseObj3 => {
                    if (responseObj3.status === 200) {
                      console.log('LOGGED ACTIVITY : ')
                    }
                  })
                } else {
                  this.$store.commit('setIsLoading', false)
                  this.showAlertDialog = true
                  this.errorMsg = 'Oops! Something went wrong. Please try again.'
                }
              }, errorObj => {
                // AK: Hide Spinner
                this.$store.commit('setIsLoading', false)
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              })
            } else {
              this.$store.commit('setIsLoading', false)
              this.showAlertDialog = true
              this.alertErrorMsg = err2.description
            }
          })
        } else {
          this.$store.commit('setIsLoading', false)
          this.showAlertDialog = true
          this.alertErrorMsg = 'Invalid username or password. Please try again.'
        }
      })
    },
    authenticateUser: function (e) {
      // AK: Added Validations
      if (this.username === undefined || this.username === 'undefined' || this.username === null || this.username === 'null' || this.username === '' || this.username.trim().length === 0) {
        this.showAlertDialog = true
        this.alertErrorMsg = 'Username can\'t be empty. Please fill in username and try again.'
        return
      } else if (this.password === undefined || this.password === 'undefined' || this.password === null || this.password === 'null' || this.password === '' || this.password.trim().length === 0) {
        this.showAlertDialog = true
        this.alertErrorMsg = 'Password can\'t be empty. Please fill in password and try again.'
        return
      }
      if (this.errors.length > 0) {
        e.preventDefault()
      } else {
        var cookies = this.$cookies
        var store = this.$store
        // AK: Show Spinner
        // this.showSpinner = true
        this.$store.commit('setIsLoading', true)
        loginService.login(this.username, this.password).then(responseObj => {
          if (responseObj.status === 200) {
            store.state.isComingFromLogin = true
            let respData = responseObj.data
            let accessToken = respData.access_token
            store.state.access_token = accessToken
            cookies.set(constants.LOGIN_COOKIE_KEY, accessToken, respData.expires_in)
            this.resetIsLogoutStateForCurrentPlatform(accessToken)
          } else {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.commit('setIsLoading', false)
            this.showAlertDialog = true
            this.alertErrorMsg = 'Sorry. we couldn\'t find an account with the credentials provided.'
          }
        }, errorObj => {
          // AK: Hide Spinner
          // this.showSpinner = false
          this.$store.commit('setIsLoading', false)
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.alertErrorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.alertErrorMsg = errorObj.response.data.error_description
          }
        })
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateShowSpinnerFlag (value) {
      // this.showSpinner = value
      this.$store.state.isLoading = value
    },
    getCourses: function () {
      var storeObj = this.$store
      courseService.listCourses(storeObj.state.access_token)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              var cdata = responseObj.data
              storeObj.state.course_list = cdata
              // AK: Required to issue this call since when user lands very first time on user page,
              // Group listing data is not present hence it shows spinner hence required to get this too
              this.getGroupList()
            } else {
              // this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              console.log('Error Occured on COURSE LISTING: ' + this.errorMsg)
            }
          }, errorObj => {
            // this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('Error Occured on COURSE LISTING: ' + this.errorMsg)
          })
    },
    getAllParticipantList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== null
      ) {
        participantService
          .getAllParticipantList(
            storeObj.state.access_token
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Assign it
                storeObj.state.userList = responseObj.data
              } else {
                // _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                console.log('Error Occured on USER LISTING: ' + _this.errorMsg)
              }
            },
            errorObj => {
              // _this.showAlertDialog = true
              if (errorObj.response === undefined) {
                _this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                _this.errorMsg = errorObj.response.statusText
              }
              console.log('Error Occured on USER LISTING: ' + _this.errorMsg)
            }
          )
      } else {
        console.log(
          'ACCESS TOKEN is NULL hence declined LOADING ALL Participant LIST OPERATION'
        )
      }
    },
    getGroupList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== ''
      ) {
        groupService
          .listGroups(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              console.log('Error Occured on GROUP LISTING: ' + _this.errorMsg)
            }
          }, errorObj => {
            // this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('Error Occured on GROUP LISTING: ' + _this.errorMsg)
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING GROUP LIST'
        )
      }
    },
    getSenderEmailList () {
      var store = this.$store
      var _this = this
      var token = store.state.access_token
      emailService.getSenderEmailList(token).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          // _this.showSpinner = false
          _this.$store.commit('setIsLoading', false)
          store.senderEmailList = responseObj.data
          // AK: Close overlay
          _this.$emit('closeOverlay', false)
        }
      }, errorObj => {
        // _this.showSpinner = false
        _this.$store.commit('setIsLoading', false)
        this.showAlertDialog = true
        if (errorObj.response === undefined) {
          this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          this.errorMsg = errorObj.response.statusText
        }
      })
    },
    getProgressionEmailTemplates () {
      var store = this.$store
      var _this = this
      var token = store.state.access_token

      emailService.getTemplateList(token, constants.EmailTemplateType.Progression).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          // _this.showSpinner = false
          _this.$store.commit('setIsLoading', false)
          store.progressionTemplateList = responseObj.data
          // AK: Close overlay
          _this.$emit('closeOverlay', false)
        }
      }, errorObj => {
        // _this.showSpinner = false
        _this.$store.commit('setIsLoading', false)
        this.showAlertDialog = true
        if (errorObj.response === undefined) {
          this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          this.errorMsg = errorObj.response.statusText
        }
      })
    }
  },
  components: {
    'alert-box': AlertBox,
    'forgot-password-overlay': ForgotPasswordOverlay,
    'loader': Loader
  }
}
</script>

<style scoped>
.form-bg {
 /* background-color:rgba(216, 177, 104, 0.973); */
 color:black;
 padding:20px;
 border-radius: 10px;
 /* position: absolute; */
 border:1px solid black;
 /* margin:auto; */
 /* top:0; */
 /* right:0; */
 /* bottom:0; */
 /* left:0; */
 /* width:320px; */
 /* height:280px;  */
}
.display-inline-block
{
  display: inline-block;
}
.float-Right
{
  float: right;
}
.margin-Top-5Perc
{
  margin-top: 5%;
}
.margin-Top-10Perc
{
  margin-top: 10%;
}
.margin-Bottom-5Perc
{
  margin-bottom: 5%;
}
.margin-Bottom-10Perc
{
  margin-bottom: 10%;
}
.background-color
{
  background-color:#f39c12;
}
.width{
  /* height:38px; */
  width:100%;
}
.height-38px{
  height:50px !important;
}
.admin-Panel-Padding
{
  padding:0.1% 0% 0.1% 2%;
}
.font-size-2vw
{
  font-size: 2vw;
}
.text-align-center {
  text-align: center;
}
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.btn-custom {
    background-color: #4CAF50;
    color: white;
    padding: 14px 20px;
    margin: 8px 0;
    border: none;
    cursor: pointer;
    width: 100%;
}
.height{
  height:270px !important;
}
.margin-Top-5Perc{
 margin-top: 5% !important;
}
.margin-Top-1Perc{
  margin-top: 1% !important;
}
.margin-Top-2Perc{
  margin-top: 2% !important;
}
.text-decoration-underline {
  text-decoration: underline;
}
.padding-Top-5Perc{
  padding-top: 5%
}
.bg-color-red{
  background-color: red;
}
.border-red{
  border: 1px solid red;
}
.width-height-10px{
  width:10% !important;
  /* height: 10% !important; */
  height:38px !important;
}
.text-color-orange {
  color: #f39c12;
  font-size: 12px;
}
.cursor-pointer {
  cursor: pointer;
}
.LoginForm {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.width-90Perc{
  width:90%;
  margin: 0 auto;
}
.panel{
  border-radius:14px;
}
.p-viewer {
  position: relative;
  margin: -25px 10px;
  float: right;
}
.color-orange {
  color: #EE6B1F;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginForm.vue